import {EntityFactory, Reducer} from '@modifi/redux'
import {createCachedSelector} from 're-reselect'
import {createSelector} from 'reselect'
import {equals} from 'ramda'
import {serviceClient} from '../../lib/ownClient'
import {RemoteRouteStruct} from './types'
import {PLUGIN_NAME} from '../../constants/routes'

const apiClient = serviceClient()

const {reducer, actions, selectors} = EntityFactory({
  actionNamePrefix: 'data/router',
  rootSelector: state => state?.plugins?.[PLUGIN_NAME]?.routes,
  fetchRequest: () =>
    apiClient.Routing.routes().then(res => res.data<{routes: RemoteRouteStruct[]}>()),
})

export default reducer as Reducer

export const aFetchRoutes = (): any => actions!.fetch({})

export const {selectIsError, selectIsLoading} = selectors

export const selectRoutes = (state: Record<string, any>): RemoteRouteStruct[] =>
  selectors.selectEntity(state)?.routes ?? []

export const selectAlternativeRoutes = createCachedSelector(
  selectRoutes,
  (
    _: Record<string, any>,
    page: Partial<
      Pick<RemoteRouteStruct, 'region' | 'locale' | 'component' | 'pageName' | 'pageType'>
    >
  ) => page,
  (
    routes,
    page: Partial<
      Pick<RemoteRouteStruct, 'region' | 'locale' | 'component' | 'pageName' | 'pageType'>
    >
  ): Record<string, Record<string, string>> => {
    // should never happen
    if (typeof page.region === 'undefined' || typeof page.locale === 'undefined') {
      return {}
    }
    return routes
      .filter(altPage => {
        if (page.component) {
          if (page.pageType && page.pageName) {
            if (
              altPage.component === page.component &&
              altPage.pageType === page.pageType &&
              altPage.pageName === page.pageName &&
              (altPage.region !== page.region || altPage.locale !== page.locale)
            ) {
              return true
            }
          } else if (
            altPage.component === page.component &&
            (altPage.region !== page.region || altPage.locale !== page.locale)
          ) {
            return true
          }
        }

        return false
      })
      .reduce((result, matchingPage) => {
        if (!matchingPage.region || !matchingPage.locale) {
          return result
        }

        if (!result[matchingPage.region]) {
          // eslint-disable-next-line no-param-reassign
          result[matchingPage.region] = {}
        }
        // eslint-disable-next-line no-param-reassign
        result[matchingPage.region][matchingPage.locale] = matchingPage.path
        return result
      }, {} as Record<string, Record<string, string>>)
  }
)(
  (state, page) =>
    `${page.region}|${page.locale}|${page.component}|${page.pageType}|${page.pageName}`
)
// export const selectPaths

export const selectFlatRouteList = createSelector(selectRoutes, routes => routes.map(r => r.path), {
  memoizeOptions: {resultEqualityCheck: equals},
})
